import React, {useState} from 'react';
import axios from 'axios';
import styled from 'styled-components';
import {TextField, Button} from '@partssourceinc/react-ui-core';
import {Link} from 'react-router-dom';
import {GenericAccountAccessMessage} from 'utils/enums';

const Container = styled.div`
    max-width: 300px;
    margin: 0 auto;
`;

const ErrorContainer = styled.div`
    max-width: 500px;
    margin: 0 auto;
`;

const EmailTextField = styled(TextField)`
    margin: 2rem 0 1rem;
`;

const Header = styled.h1`
    margin-bottom: 3rem;
`;

const View = {
    FORM: 0,
    SUCCESS: 1,
    ERROR: 2,
};

const ApiResult = {
    SUCCESS: 0,
    EMAIL_NOT_FOUND: 1,
    MISC_ERROR: 2,
    MULTIPLE_CONTACTS_FOUND: 3,
};

const ForgotPassword = () => {
    const [{view, message}, setView] = useState({view: View.FORM});
    const [email, setEmail] = useState('');
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    function handleEmailChange(e) {
        setEmail(e.target.value);
        setIsError(false);
    }

    async function handleFormSubmit(e) {
        e.preventDefault();
        if (!email) {
            setIsError(true);
            return;
        }

        setIsLoading(true);
        try {
            const {data: {result}} = await axios.post(
                `${process.env.REACT_APP_ORION_API_ROUTE_URL}/ShoppingService/api/v1/account/ForgotPassword`,
                {email}
            );
            setIsLoading(false);

            switch (result) {
                case ApiResult.SUCCESS:
                    setView({view: View.SUCCESS});
                    break;
                case ApiResult.EMAIL_NOT_FOUND:
                case ApiResult.MULTIPLE_CONTACTS_FOUND:
                case ApiResult.MISC_ERROR:
                default:
                    setView({
                        view: View.ERROR,
                        message: GenericAccountAccessMessage,
                    });
                    break;
            }
        } catch {
            setIsLoading(false);
            setView({
                view: View.ERROR,
                message: GenericAccountAccessMessage,
            });
        }

        return false;
    }

    function resetPage() {
        setEmail('');
        setIsLoading(false);
        setIsError(false);
        setView({view: View.FORM});
    }

    switch (view) {
        case View.SUCCESS:
            return (
                <Container>
                    <Header>The information has been sent</Header>
                    <Link to="/">Return to Homepage</Link>
                </Container>
            );
        case View.ERROR:
            return (
                <ErrorContainer>
                    <Header>{message}</Header>
                    <Link to="/forgot-password" onClick={resetPage}>Please try again</Link>
                </ErrorContainer>
            );
        case View.FORM:
        default:
            return (
                <Container>
                    <Header>Forgot Password</Header>
                    <form onSubmit={handleFormSubmit}>
                        <EmailTextField
                            label="Email or User ID"
                            placeholder="Email or User ID"
                            showErrorMessage={isError}
                            errorMessage="Email or User ID is required"
                            onChange={handleEmailChange}
                        />
                        <Button type="submit" loading={isLoading} disabled={!email} secondary={true}>Send</Button>
                    </form>
                </Container>
            );
    }
};

export default ForgotPassword;
